var _filter, _filter2, _filter3, _clipPath, _circle, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatbot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 368,
    viewBox: "0 0 577 368",
    width: 577,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 164,
    width: 264,
    x: 294,
    y: 75
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.105882 0 0 0 0 0.278431 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_3_44555"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_44555",
    mode: "normal",
    result: "shape"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "b",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 164,
    width: 254,
    x: 214,
    y: 191
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.105882 0 0 0 0 0.278431 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_3_44555"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_44555",
    mode: "normal",
    result: "shape"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "c",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 104,
    width: 104,
    x: 166,
    y: 251
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.105882 0 0 0 0 0.278431 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_3_44555"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_44555",
    mode: "normal",
    result: "shape"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m346 109h32v32h-32z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 331,
    cy: 507,
    fill: "#f5f7f9",
    r: 331
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m326 115c0-11.046 8.954-20 20-20h160c11.046 0 20 8.954 20 20v76c0 2.209-1.791 4-4 4h-176c-11.046 0-20-8.954-20-20z",
    fill: "#1b75ba"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m350.321 117.131c.835-.584 2.095-.472 2.845.147l-.86-1.25c-.693-.988-.445-2.056.544-2.75.988-.69 3.789 1.166 3.789 1.166-.699-.997-.568-2.261.429-2.96.998-.697 2.374-.456 3.072.543l9.263 13.084-1.181 11.445-9.851-3.593-8.593-12.741c-.705-1.003-.462-2.387.543-3.091z",
    fill: "#ef9645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.396 124.41s-1.007-1.467.461-2.472c1.466-1.006 2.471.46 2.471.46l4.668 6.807c.16-.268.336-.533.533-.794l-6.478-9.447s-1.006-1.465.461-2.471c1.466-1.005 2.471.461 2.471.461l6.093 8.886c.227-.185.459-.371.698-.553l-7.064-10.303s-1.005-1.466.462-2.471c1.465-1.005 2.471.46 2.471.46l7.064 10.302c.259-.159.516-.297.774-.443l-6.603-9.628s-1.005-1.466.461-2.472c1.465-1.005 2.471.461 2.471.461l6.981 10.181 1.061 1.549c-4.398 3.017-4.816 8.692-2.304 12.357.503.733 1.236.231 1.236.231-3.016-4.399-2.095-9.342 2.304-12.358l-1.297-6.491s-.484-1.71 1.225-2.195c1.71-.485 2.196 1.225 2.196 1.225l1.497 4.448c.594 1.764 1.226 3.521 2.063 5.184 2.361 4.693.951 10.526-3.503 13.581-4.857 3.331-11.498 2.092-14.83-2.765z",
    fill: "#ffcc4d"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5dadec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m356.667 137.482c-3.556 0-7.149-3.593-7.149-7.149 0-.491-.36-.889-.851-.889-.492 0-.927.398-.927.889 0 5.334 3.593 8.927 8.927 8.927.491 0 .889-.435.889-.927 0-.491-.398-.851-.889-.851z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.222 139.222c-2.666 0-4.444-1.778-4.444-4.444 0-.492-.398-.889-.889-.889-.492 0-.889.397-.889.889 0 3.555 2.667 6.222 6.222 6.222.492 0 .889-.397.889-.889 0-.491-.397-.889-.889-.889zm15.111-28.444c-.49 0-.889.398-.889.889 0 .49.399.889.889.889 3.556 0 7.111 3.19 7.111 7.111 0 .49.399.889.889.889.491 0 .889-.399.889-.889 0-4.902-3.555-8.889-8.889-8.889z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.778 109.037c-.491 0-.889.361-.889.852s.398.926.889.926c2.666 0 4.407 1.978 4.407 4.407 0 .491.435.889.926.889.492 0 .852-.398.852-.889 0-3.41-2.63-6.185-6.185-6.185z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#d3dbe5"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 12,
    opacity: 0.56,
    rx: 6,
    width: 160,
    x: 346,
    y: 149
  }), /*#__PURE__*/React.createElement("rect", {
    height: 12,
    opacity: 0.56,
    rx: 6,
    width: 110,
    x: 346,
    y: 169
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m246 231c0-11.046 8.954-20 20-20h150c11.046 0 20 8.954 20 20v60c0 11.046-8.954 20-20 20h-150c-11.046 0-20-8.954-20-20z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.316 241c0 7.907-6.409 14.316-14.316 14.316s-14.316-6.409-14.316-14.316 6.409-14.316 14.316-14.316 14.316 6.409 14.316 14.316z",
    fill: "#ffcc4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.947 241c0 2.326-1.885 4.211-4.21 4.211s-4.211-1.885-4.211-4.211c0-2.325 1.886-4.211 4.211-4.211s4.21 1.886 4.21 4.211z",
    fill: "#ff7892"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.474 241c0 2.326-1.885 4.211-4.211 4.211s-4.21-1.885-4.21-4.211c0-2.325 1.884-4.211 4.21-4.211s4.211 1.886 4.211 4.211z",
    fill: "#ff7892"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#664500"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m289.861 244.056c-.15-.136-.374-.144-.535-.025-.033.025-3.302 2.443-7.326 2.443-4.013 0-7.294-2.418-7.326-2.443-.161-.119-.385-.109-.535.025-.149.135-.183.357-.079.529.108.181 2.709 4.415 7.94 4.415s7.832-4.234 7.94-4.415c.104-.173.071-.394-.079-.529z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.578 238.474c-.126 0-.255-.029-.375-.089-.416-.209-.586-.715-.378-1.13.045-.088 1.111-2.15 4.122-2.15 3.013 0 4.078 2.063 4.122 2.15.209.416.039.921-.377 1.13-.413.206-.913.041-1.125-.368-.036-.066-.699-1.228-2.62-1.228-1.951 0-2.609 1.207-2.614 1.219-.149.296-.446.466-.755.466z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.422 238.474c-.309 0-.606-.17-.755-.466-.021-.039-.678-1.219-2.614-1.219s-2.594 1.18-2.621 1.23c-.219.405-.724.564-1.133.354-.408-.213-.574-.706-.368-1.118.043-.087 1.11-2.15 4.122-2.15s4.078 2.063 4.121 2.15c.209.416.04.921-.376 1.13-.121.06-.25.089-.376.089z"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#d3dbe5",
    height: 12,
    opacity: 0.56,
    rx: 6,
    width: 150,
    x: 266,
    y: 265
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#d3dbe5",
    height: 12,
    opacity: 0.56,
    rx: 6,
    width: 80,
    x: 266,
    y: 285
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 40,
    rx: 20,
    width: 40,
    x: 198,
    y: 271
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m225.406 281.625c0 .88-.713 1.594-1.594 1.594-.88 0-1.593-.714-1.593-1.594s.713-1.594 1.593-1.594c.881 0 1.594.714 1.594 1.594zm1.5 6.375.094 1.312c1.219 0 2.156 1.032 2.25 2.25v1.594c0 1.219-1.031 2.25-2.25 2.25h-.094v2.25c-.094 1.969-1.594 3.469-3.562 3.469h-3.563c-.281.656-1.031 1.125-1.781 1.125-1.125 0-1.969-.938-1.969-1.969 0-1.125.844-1.969 1.969-1.969.75 0 1.5.376 1.781 1.126h3.563c1.031 0 1.875-.844 1.875-1.876v-9.468c0-1.032-.844-1.875-1.875-1.875h-10.782c-1.031 0-1.875.843-1.875 1.875v7.5h-1.687c-1.219-.094-2.25-1.125-2.25-2.344v-1.594c0-1.312 1.031-2.344 2.25-2.344h.188v-1.312c0-1.969 1.593-3.469 3.468-3.562h10.782c1.968.093 3.468 1.593 3.468 3.562zm-14.719-4.781c.88 0 1.594-.714 1.594-1.594s-.714-1.594-1.594-1.594-1.594.714-1.594 1.594.714 1.594 1.594 1.594zm7.875 13.406-1.875-1.406-1.968 1.406-2.157-1.594c-.281-.281-.281-.656-.093-.937.281-.282.656-.282.937-.094l1.406 1.031 1.875-1.406 1.875 1.406 1.407-1.031c.281-.281.75-.188.937.094.281.281.188.75-.094.937l-.375.188zm-4.969-4.594c.88 0 1.594-.713 1.594-1.593 0-.881-.714-1.594-1.594-1.594s-1.594.713-1.594 1.594c0 .88.714 1.593 1.594 1.593zm7.407-1.593c0 .88-.713 1.593-1.593 1.593-.881 0-1.594-.713-1.594-1.593 0-.881.713-1.594 1.594-1.594.88 0 1.593.713 1.593 1.594z",
    fill: "#647491",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbot);
export default __webpack_public_path__ + "static/media/chatbot.0271eac58d78e75001069b8104cc66ef.svg";
export { ForwardRef as ReactComponent };